import {Component, OnInit} from '@angular/core';
import {MatError, MatFormField, MatHint} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {NgIf} from "@angular/common";
import {SharedModule} from "../../../../../modules/shared/shared.module";
import {BaseMetadataAbstract} from "../BaseMetadata.abstract";
import {FormControl, ValidatorFn, Validators} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {MetaDataOnlyreadComponent} from "../meta-data-onlyread/meta-data-onlyread.component";
import {DmsMetaService} from "../../../../../services/api/dms-meta.service";

@Component({
    selector: 'app-meta-data-workflow',
    imports: [
        MatError,
        MatFormField,
        MatHint,
        MatInput,
        NgIf,
        SharedModule,
        TranslateModule,
        MetaDataOnlyreadComponent
    ],
    templateUrl: './meta-data-workflow.component.html',
    styleUrls: ['../metadata-style.scss'],
  standalone: true
})
export class MetaDataWorkflowComponent extends BaseMetadataAbstract<string, string, string> implements OnInit{

  workflowFormControl!: FormControl;
  isSearchActive = false;

  constructor(private dmsMetaService: DmsMetaService) {
    super();
  }

  ngOnInit() {
    this.initializeFormControl();
    this.workflowFormControl.markAsTouched();
  }

  private initializeFormControl() {
    const validators: ValidatorFn[] = [
    ];

    if (this.visibility === 'MT_K') {
      validators.push(Validators.required);
    }

    this.workflowFormControl = new FormControl(this.humanvalue || this.value, validators);
  }

  onInput(typedValue: string){
    this.workflowFormControl.setErrors(null);
    this.onChangeValue('');
    this.onChangeHumanValue(typedValue);
  }

  onBlur(typedValue: string){
    if(!typedValue){
      return;
    }

    this.isSearchActive = true;
    this.dmsMetaService.readDmsAcWorkflowByNumber$(typedValue).subscribe({
      next: response => {
        this.isSearchActive = false;
        const result = response?.result as { id?: number };
        if(result && result.id != null){
          this.onChangeValue(String(result.id));
          this.onChangeHumanValue(typedValue);
        } else {
          this.workflowFormControl.setErrors({ itemNotExist: true });
        }
      },
      error: () => {
        this.isSearchActive = false;
        this.workflowFormControl.setErrors({ itemNotExist: true });
      }
    });
  }

}
